import React from 'react';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Quieres generar un ingreso propio pero no sabes por dónde empezar ni qué habilidad aprender', 'Piensas que fabricar muebles es demasiado difícil y sientes que no te saldrían bien', 'Estás harto de depender de un sueldo fijo y un jefe que decide cuánto vales cada mes', 'Sientes que hagas lo que hagas, no creces… y que las oportunidades siempre son para otro'];
  return <section className="py-4 md:py-10 px-6 bg-metal bg-blueprint" data-id="element-169">
      
      
        
          <p className="text-lg md:text-2xl text-[#E4D6B5] leading-relaxed mb-6 md:mb-8 font-bold" data-id="element-170">
            <span className="font-black uppercase tracking-wide" data-id="element-171">
              ¿Te pasa algo de esto?
          
            </span>
          </p>

          <div className="space-y-3 md:space-y-4 mb-8 md:mb-12" data-id="element-172">
            {problems.map((problem, index) => <div key={index} className="flex items-start gap-3 md:gap-4 bg-[#111111] p-3 md:p-5 border-l-4 border-[#8B5A2B] shadow-lg" data-id="element-173">
                <XCircle className="w-5 md:w-7 h-5 md:h-7 text-[#8B5A2B] flex-shrink-0 mt-1" data-id="element-174" />
                <p className="text-sm md:text-lg text-[#E4D6B5] leading-relaxed font-semibold" data-id="element-175">
                  <span className="text-[#C8B894]" data-id="element-176">→ {problem}</span>
                </p>
              </div>)}
          </div>        
        
     
    </section>;
}